import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IDevice } from './device';
import { IDeviceFormValues } from './deviceFormValues';
import { IDeviceUpsert } from './deviceUpsert';

export default class DeviceModelHelper {
    public static createFormValues = (device : IDevice | null) : IDeviceFormValues => {
        if (!device) return {
            id: 0,
            guid: uuidV4(),
            name: '',
            serialNumber: '',
            isActive: true,
        };

        return {
            id: device.id,
            guid: device.guid,
            name: device.name,
            serialNumber: device.serialNumber,
            isActive: device.isActive,
        };
    };

    public static createUpsert = (formValues : IDeviceFormValues) : IDeviceUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            name: formValues.name,
            serialNumber: formValues.serialNumber,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IDeviceFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        serialNumber: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
